// Aurora theme: minimal, dependency-free interactions

document.addEventListener('DOMContentLoaded', () => {
  const REDUCED_MOTION = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CHECK_SVG =
    '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6.5 9.5 17 4 11.5"/></svg>';

  // Scroll-reveal animation
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-inview');
        io.unobserve(e.target);
      }
    }),
    { threshold: 0.12 }
  );
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // Mobile menu toggle
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // Product gallery: click thumbnail to swap main image
  const mainImage = document.querySelector('[data-main-image] img');
  const thumbs = document.querySelectorAll('[data-thumb]');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.full;
      mainImage.srcset = '';
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // Variant selection: map option selects to the matching variant id
  const productJson = document.querySelector('[data-product-json]');
  const variantInput = document.querySelector('[data-variant-id]');
  const priceEl = document.querySelector('[data-price]');

  if (productJson && variantInput) {
    const product = JSON.parse(productJson.textContent);
    const selects = document.querySelectorAll('.product-form__option select');
    const moneyFormat = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(cents / 100);

    const updateVariant = () => {
      const chosen = Array.from(selects).map((s) => s.value);
      const variant = product.variants.find((v) =>
        chosen.every((value, i) => v.options[i] === value)
      );
      if (!variant) return;

      variantInput.value = variant.id;

      const button = document.querySelector('.product-info .btn--primary');
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? button.dataset.addLabel || 'Add to cart'
          : button.dataset.soldLabel || 'Sold out';
      }
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
    };

    selects.forEach((s) => s.addEventListener('change', updateVariant));
  }

  /* ---------- Quantity steppers (product page + cart) ---------- */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const stepper = (minus || plus).closest('.qty-stepper');
    const input = stepper && stepper.querySelector('input');
    if (!input) return;
    const min = parseInt(input.min || '0', 10);
    const next = Math.max(min, parseInt(input.value || '0', 10) + (plus ? 1 : -1));
    if (next === parseInt(input.value || '0', 10)) return;
    input.value = next;
    input.classList.remove('is-pop');
    void input.offsetWidth;
    input.classList.add('is-pop');
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product options: pills + custom dropdowns ---------- */
  document.querySelectorAll('[data-option-wrap]').forEach((wrap) => {
    const select = wrap.querySelector('[data-option-select]');
    const current = wrap.querySelector('[data-option-current]');
    const dropdown = wrap.querySelector('[data-option-dropdown]');
    if (!select) return;

    const choose = (value) => {
      select.value = value;
      if (current) current.textContent = value;
      wrap.querySelectorAll('[data-option-pill]').forEach((b) =>
        b.classList.toggle('is-selected', b.dataset.value === value)
      );
      wrap.querySelectorAll('[data-option-item]').forEach((b) => {
        const active = b.dataset.value === value;
        b.classList.toggle('is-active', active);
        const oldCheck = b.querySelector('svg.icon');
        if (oldCheck) oldCheck.remove();
        if (active) b.insertAdjacentHTML('beforeend', CHECK_SVG);
      });
      if (dropdown) dropdown.removeAttribute('open');
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    wrap.addEventListener('click', (e) => {
      const target = e.target.closest('[data-option-pill], [data-option-item]');
      if (target) choose(target.dataset.value);
    });
  });

  /* Close any open dropdown when clicking outside it */
  document.addEventListener('click', (e) => {
    document.querySelectorAll('details.dropdown[open], details.locale[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- Add-to-cart animations ---------- */

  const cartIcon = document.querySelector('.header-icon[href*="/cart"]');

  function bumpCartIcon(count) {
    let badge = document.querySelector('[data-cart-count]');
    if (!badge && cartIcon) {
      badge = document.createElement('span');
      badge.className = 'cart-count';
      badge.setAttribute('data-cart-count', '');
      cartIcon.appendChild(badge);
    }
    if (badge) {
      if (typeof count === 'number') badge.textContent = count;
      badge.classList.remove('is-pop');
      void badge.offsetWidth;
      badge.classList.add('is-pop');
    }
    if (cartIcon && !REDUCED_MOTION) {
      cartIcon.classList.remove('is-bump');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('is-bump');
      setTimeout(() => cartIcon.classList.remove('is-bump'), 600);
    }
  }

  function flyToCart(fromEl, count) {
    if (REDUCED_MOTION || !fromEl || !cartIcon || !document.body.animate) {
      return bumpCartIcon(count);
    }
    const a = fromEl.getBoundingClientRect();
    const b = cartIcon.getBoundingClientRect();
    const dot = document.createElement('div');
    dot.className = 'fly-dot';
    dot.style.left = a.left + a.width / 2 - 6 + 'px';
    dot.style.top = a.top + a.height / 2 - 6 + 'px';
    document.body.appendChild(dot);

    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    dot.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.55}px, ${dy * 0.55 - 70}px) scale(0.85)`, opacity: 1, offset: 0.55 },
        { transform: `translate(${dx}px, ${dy}px) scale(0.25)`, opacity: 0.4 },
      ],
      { duration: 650, easing: 'cubic-bezier(0.3, 0.05, 0.4, 1)' }
    ).onfinish = () => {
      dot.remove();
      bumpCartIcon(count);
    };
  }

  /* AJAX add-to-cart: no page reload, button morphs to a success state.
     Falls back to a normal form submit if the request fails. */
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button?.dataset.busy) return;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) throw new Error('add failed');
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

        if (button) {
          button.dataset.busy = '1';
          const original = button.innerHTML;
          const isQuickAdd = button.classList.contains('product-card__quick');
          button.classList.add('is-added');
          button.innerHTML = isQuickAdd
            ? CHECK_SVG.replace('<svg ', '<svg class="icon-swap" ')
            : '<span class="btn__label">' + CHECK_SVG + (button.dataset.addedLabel || 'Added') + '</span>';
          setTimeout(() => {
            button.classList.remove('is-added');
            button.innerHTML = original;
            delete button.dataset.busy;
          }, 1500);
        }
        flyToCart(button, cart.item_count);
      } catch {
        form.submit();
      }
    });
  });
});
